import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import * as angular from 'angular';
import {InternalErrorComponent} from "./internal-error.component";

/*
* Workaround para que siga funcionando la configuración
* $routeProvider.otherwise() que redirige a la pantalla de error
* cuando se ingresan URLs desconocidas.
* */
angular.module('CarsSaraBo')
    .config(['$routeProvider', ($routeProvider) => {
        $routeProvider.when('/internal-error', {template: ''});
    }]);
/***/

const internalErrorRoutes: Routes = [
    {path: 'internal-error', component: InternalErrorComponent},
    {path: 'cars-sara-v2/web/internal-error', component: InternalErrorComponent}
];

@NgModule({
    imports: [
        RouterModule.forChild(internalErrorRoutes)
    ],
    exports: [
        RouterModule
    ]
})
export class InternalErrorRoutingModule {
}


// WEBPACK FOOTER //
// ./public/upgrade/feature/internal-error/internal-error-routing.module.ts